import { apiPost } from './apiClient';

export interface SubscribeBody {
  email: string;
  // Honeypot — must match the hidden field name the backend expects. Real users
  // leave it blank; the server silently drops requests where it is filled.
  website?: string;
}

export function subscribeNewsletter(body: SubscribeBody): Promise<{ message: string }> {
  return apiPost('/api/newsletter/subscribe', body);
}
